export const MHA_STATUS_DASHBOARD_KEY = "mha-status";
//# sourceMappingURL=reports.js.map